import React from 'react';
import PolicyLayout from './PolicyLayout';

const CookiesPolicy = () => (
  <PolicyLayout title="Cookies Policy" updated="14 September 2026">
    <h2>1. Introduction</h2>
    <p>
      This Cookies Policy ("Policy") describes the use of cookies and
      similar technologies within the Project Green Intranet portal
      ("the Portal") by Project Green ("the Company", "we", "us", or
      "our"). As the Portal is an internal, authenticated system
      accessible only to Authorised Users, the scope of cookie usage
      described herein is limited relative to that of a public website.
    </p>

    <h2>2. Definition of Cookies</h2>
    <p>
      A cookie is a small text file placed on your device by your
      browser at the request of a website or application, which enables
      that website or application to recognise your device and retain
      certain information between sessions.
    </p>

    <h2>3. Categories of Cookies Used</h2>
    <p><strong>3.1 Strictly Necessary Cookies.</strong> These cookies are essential to enable core functionality of the Portal and cannot be disabled without impairing your ability to access it. They include:</p>
    <ul>
      <li>authentication cookies set by Azure Active Directory (Azure AD B2C), used to establish and maintain a secure session; and</li>
      <li>session-management cookies used to preserve navigation state and enforce security controls during your use of the Portal.</li>
    </ul>
    <p>
      As these cookies are strictly necessary for the provision of the
      Portal, the Company is not required to obtain your consent to
      their use.
    </p>

    <p><strong>3.2 Functional Cookies.</strong> These cookies enable the Portal to remember choices you make, such as display or layout preferences, in order to provide a more personalised experience. The Portal remains substantively operable without these cookies.</p>

    <h2>4. Cookies Not Used</h2>
    <p>
      The Company does not deploy advertising, targeting, or third-party
      marketing cookies within the Portal. Any usage or performance
      statistics collected are aggregated and used solely for internal
      administrative purposes; they are not used to track Authorised
      Users across unrelated websites or services.
    </p>

    <h2>5. Managing and Withdrawing Consent</h2>
    <p>
      Where cookies are not strictly necessary, you may manage or
      withdraw your consent to their use through your browser settings
      at any time. Please note that disabling strictly necessary cookies
      will prevent you from authenticating to, or otherwise using, the
      Portal.
    </p>

    <h2>6. Amendments to this Policy</h2>
    <p>
      The Company reserves the right to amend this Policy from time to
      time to reflect changes in the technologies used within the
      Portal. Any amendment will be published on this page together with
      an updated revision date.
    </p>

    <h2>7. Contact Details</h2>
    <div className="policy-contact-box">
      <p><strong>Data Protection Officer</strong></p>
      <p>Email: dpo.pg@projectgreen.mt</p>
    </div>
  </PolicyLayout>
);

export default CookiesPolicy;